<template>
  <div class="component-form-search-skus">
    <div style="position: relative;">
      <div class="input-back"><i class="fa fa-lg fa-search"></i></div>
      <input type="text"
             name="sku"
             placeholder="O que você precisa alugar?"
             v-model="search"
             @keyup.enter.prevent="setSku(false)"
             @keyup="doSearch"
             @keyup.arrow-vertical-keys.prevent="navigate"
             @blur="hide()"
             @focus="show()"
             class="form-control input-lg"
             autocomplete="off">
      <table v-if="visible && skus.length > 0 || loading" class="table table-condensed table-bordered table-hover">
        <tbody>
        <tr v-if="loading">
          <td class="text-center">
            <loading/>
          </td>
        </tr>
        <tr v-else="" v-for="(sku, k) in skus" :class="{ 'active': k == focus }" @click="setSku(k)">
          <td>
            <img :src="sku.image" alt="" class="photo">
            <div class="sku-title">{{ sku.title }}</div>
          </td>
        </tr>
        </tbody>
      </table>
      <table v-else-if="searched" class="table table-condensed table-bordered table-hover">
        <tbody>
        <tr>
          <td>
            <div class="title title-form title-default">Nenhum produto encontrado!</div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
  import {mapState, mapActions} from 'vuex'

  export default{
    name: 'FormSearchSkus',
    components: {},
    props: [],
    data () {
      return {
        focus: 0,
        visible: false,
        search: '',
        searched: false,
        beforeRequest: false,
        skus: [],
        loading: false
      }
    },
    computed: {
      ...mapState({
        user: state => state.user
      })
    },
    mounted () {},
    methods: {
      show () {
        this.visible = true
      },
      hide (reset = false) {
        setTimeout(() => {
          this.searched = false
          this.visible = false
          if (reset) this.skus = []
        }, 100)
      },
      setSku (k) {
        if (k) this.focus = k
        this.$router.push({
          name: 'sku',
          params: {
            categorySlug: this.skus[this.focus].categorySlug,
            subcategorySlug: this.skus[this.focus].subcategorySlug,
            productSlug: this.skus[this.focus].productSlug,
            skuSlug: this.skus[this.focus].slug,
            skuId: this.skus[this.focus].id
          }
        })
      },
      navigate (event) {
        if (event.keyCode === 38) {
          if (this.focus > 0) this.focus -= 1
        }
        if (event.keyCode === 40) {
          if (this.focus < (this.skus.length - 1)) this.focus += 1
        }
      },
      doSearch (event) {
        if (this.search === '' || this.search.length < 3) {
          this.hide()
        } else if (![37, 38, 39, 40, 13, 16, 17, 18, 20, 91, 93, 33, 34, 35, 36].includes(event.keyCode)) {
          this.show()
          this.focus = 0
          this.$http.get('skus?parent=search&search=' + this.search, {
            before (request) {
              this.loading = true
              if (this.beforeRequest) this.beforeRequest.abort()
              this.beforeRequest = request
            }
          }).then((response) => {
            this.skus = response.data
            this.searched = true
            this.loading = false
          }, (error) => {
            if (error.status !== 0) {
              this.loading = false
            }
          })
        }
      },
      ...mapActions([])
    }
  }
</script>


// WEBPACK FOOTER //
// FormSearchSkus.vue?12f8439e